import fetch from '../fetch';
import url from './feedback-url';

export default {
  getFeedBackList(params: any) {
    return fetch({
      url: url.getFeedbackList,
      method: 'get',
      params,
    });
  },
  getFeedBackConfig(params: any) {
    return fetch({
      url: url.getFeedBackConfig,
      method: 'get',
      params,
    });
  },
  postFeedBack(data: any) {
    return fetch({
      url: url.postFeedBack,
      method: 'post',
      data,
    });
  },
  // 取消工单
  postCancel(data: any) {
    return fetch({
      url: url.postCancel,
      method: 'post',
      params: data,
    });
  },
  // 关闭工单
  postFinish(data: any) {
    return fetch({
      url: url.postFinish,
      method: 'post',
      params: data,
    });
  },
  // 确认未解决
  postReopen(data: any) {
    return fetch({
      url: url.postReopen,
      method: 'post',
      params: data,
    });
  },
  // 回复工单
  postReply(data: any) {
    return fetch({
      url: url.postReply,
      method: 'post',
      data,
    });
  },
};
